import React, { useContext, useEffect, useState } from 'react';
import {
  Avatar,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  // TextField,
} from '@material-ui/core';
import {
  Edit,
  // Notifications,
  // Today
} from '@material-ui/icons';

import { useHistory } from 'react-router-dom';

import moment from 'moment';

import PropTypes from 'prop-types';

import AlertDialog1Option from '../../modals/alertDialog1Option';
import SearchField from '../../fields/searchField';
import TablePaginationActions from '../../fields/tablePaginationActions';

import { filteredSearch, getColors, getComparator, remainingDays, stableSort } from '../../../utils/helpers';
import { defaultRowsPerPage, defaultSortOrder, extraDays, rowsPerPageOptions, greenColor, amberColor, redColor } from '../../../utils/constants';

import translations from '../../../languages/i18n';

import { customOptionsTableStyles } from '../../../styles/formElementsStyles';

import { SessionContext } from '../../../utils/context';

export default function MySchedulesList({ schedulesData, editScheduleData }) {
  const history = useHistory();
  const classesForm = customOptionsTableStyles();

  const sessionContext = useContext(SessionContext);

  const [externalPlatforms, setExternalPlatforms] = useState([]);
  const [filteredSchedules, setFilteredSchedules] = useState([]);
  const [formattedscheduleData, setFormattedscheduleData] = useState([]);
  const [order, setOrder] = React.useState(defaultSortOrder); // Indica l'ordre per defecte
  const [orderBy, setOrderBy] = React.useState('from'); // Indica la columna per la que ordenam per defecte
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [searchString, setSearchString] = useState('');
  const [showExternalPlatforms, setShowExternalPlatforms] = useState(false);

  const getAdaptedFormat = (dataList) => {
    const out = [];
    dataList.map((item) => {
      const N = item.daysToFillIn + extraDays;
      const valueState = remainingDays(item.from, item.daysToFillIn);
      // const isNotActiveYet = moment().isBefore(moment(item.from).format('LL'), 'd');
      // AMB format DD-MM-YYYY també dona el warning!
      // Explicació: https://stackoverflow.com/questions/39969570/deprecation-warning-in-moment-js-not-in-a-recognized-iso-format
      // i aquí: https://momentjs.com/docs/#/parsing/string/
      // const isNotActiveYet = moment().isBefore(moment(item.from).format('YYYY-MM-DD'), 'd');
      // if (valueState > 0 && !isNotActiveYet) {
      if (valueState > 0) {
        out.push({
          _id: item._id,
          clinicianFormsPlatforms: item.clinicianFormsPlatforms,
          // from: moment(item.from).format('LL'),
          from: moment(item.from).format('YYYY-MM-DD'),
          scheduleName: item.name,
          translatedScheduleName: translations[item.name],
          programName: item.programName,
          programId: item.programId,
          // to: moment(item.from).add(item.daysToFillIn, 'days').format('LL'),
          to: moment(item.from).add(item.daysToFillIn, 'days').format('YYYY-MM-DD'),
          state: valueState,
          patientName: item.patientName,
          colors: getColors(N),
        });
      }
    });
    return out;
  };

  useEffect(() => {
    const schedulesDataAdapted = getAdaptedFormat(schedulesData);
    setFormattedscheduleData(schedulesDataAdapted);
  }, [schedulesData]);

  useEffect(() => {
    if (formattedscheduleData) {
      setFilteredSchedules(formattedscheduleData.slice());
      setSearchString('');
    }
  }, [formattedscheduleData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const searchSchedule = (string) => {
    setPage(0);
    setSearchString(string);
    setFilteredSchedules(filteredSearch(formattedscheduleData, string, ['translatedScheduleName', 'programName', 'patientName']));
  };

  /* const sendNewSchedule = (dateTo, idSchedule) => {
    const schedule = schedulesData.filter((item) => item._id === idSchedule);
    const newDaysToFillIn = moment(dateTo).diff(moment(schedule[0].from), 'd');
    // newDaysToFillIn no inclou el día de la nova data TO.
    // Incrementam 1 per a que s'inclogui
    const out = { ...schedule[0], daysToFillIn: newDaysToFillIn + 1 };
    editScheduleData(out, idSchedule, sessionContext.userToken);
  }; */

  const handleViewUserSchedule = (userScheduleId, programId, clinicianFormsPlatforms) => {
    let fillInOnExternalPlatforms = false;
    // Miram si el formulari s'ha de contestar des d'alguna plataforma que no sigui la web del servidor (ICHOM_web)
    fillInOnExternalPlatforms = !clinicianFormsPlatforms.includes('ICHOM_web');
    if (fillInOnExternalPlatforms) {
      setExternalPlatforms(clinicianFormsPlatforms);
      setShowExternalPlatforms(true);
    } else {
      history.push(`/${sessionContext.role.toLowerCase()}/formInfo/${programId}/${userScheduleId}`);
    }
  };

  const manageExternalPlatforms = () => {
    setShowExternalPlatforms(false);
    setExternalPlatforms([]);
  };

  const schedulesDataColumns = 7; // Per saber el nombre de propietats de cada objecte
  return (
    <React.Fragment>
      <AlertDialog1Option open={showExternalPlatforms} handleClose={manageExternalPlatforms} title={translations['_externalPlatformsAlertTitle']} message={translations['_externalPlatformsAlertMessage']} data={externalPlatforms} />
      <div>
        <TableContainer component={Paper}>
          <Table aria-label='schedule list table'>
            <TableHead>
              <TableRow>
                {/* ATENCIÓ: si pintam la columna _id afegir +1 al colSpan */}
                <TableCell colSpan={schedulesDataColumns + 2} align='left' padding='none'>
                  <SearchField handleChange={(string) => searchSchedule(string)} value={searchString} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={classesForm.tableRowHeaderBgColor}>
                {/* ATENCIÓ: no pintam la columna _id */}
                <TableCell align='left'>
                  <TableSortLabel
                    active={orderBy === 'scheduleName'}
                    direction={orderBy === 'scheduleName' ? order : 'asc'}
                    onClick={() => handleRequestSort('scheduleName')}
                  >
                    <strong>{translations['_scheduleName']}</strong>
                  </TableSortLabel>
                </TableCell>
                <TableCell align='left'><strong>{translations['_state']}</strong></TableCell>
                <TableCell align='left'>
                  <TableSortLabel
                    active={orderBy === 'from'}
                    direction={orderBy === 'from' ? order : 'asc'}
                    onClick={() => handleRequestSort('from')}
                  >
                    <strong>{translations['_from']}</strong>
                  </TableSortLabel>
                </TableCell>
                <TableCell align='left'>
                  <TableSortLabel
                    active={orderBy === 'to'}
                    direction={orderBy === 'to' ? order : 'asc'}
                    onClick={() => handleRequestSort('to')}
                  >
                    <strong>{translations['_to']}</strong>
                  </TableSortLabel>
                </TableCell>
                {/* <TableCell align='left'><strong>{translations['_notify']}</strong></TableCell> */}
                <TableCell align='left'>
                  <TableSortLabel
                    active={orderBy === 'patientName'}
                    direction={orderBy === 'patientName' ? order : 'asc'}
                    onClick={() => handleRequestSort('patientName')}
                  >
                    <strong>{translations['_patient']}</strong>
                  </TableSortLabel>
                </TableCell>
                <TableCell align='left'>
                  <TableSortLabel
                    active={orderBy === 'programName'}
                    direction={orderBy === 'programName' ? order : 'asc'}
                    onClick={() => handleRequestSort('programName')}
                  >
                    <strong>{translations['_program']}</strong>
                  </TableSortLabel>
                </TableCell>
                <TableCell align='center' />
              </TableRow>
              {(rowsPerPage > 0
                // ATENCIÓ: l'ordenació es fa damunt filteredSchedules, si no s'ha introduit res al camp de cerca el filteredSchedules inclou tot el schedulesData,
                // és a dir, l'ordenació no es fa sobre la "pagina de formularis" que es mostra al llistat (estigui filtrada o no)
                ? stableSort(filteredSchedules, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : stableSort(filteredSchedules, getComparator(order, orderBy))
              ).map((data, index) => (
                <TableRow key={data._id} className={index % 2 ? classesForm.tableRowBgColor1 : classesForm.tableRowBgColor2} hover>
                  {/* ATENCIÓ: no pintam la columna _id */}
                  <TableCell align='left'>{translations[data.scheduleName]}</TableCell>
                  <TableCell align='center'>
                    {data.state <= data.colors.red 
                      ? <Avatar variant='rounded' style={{ color: '#fff', backgroundColor: redColor, height: 30 }}>{data.state}</Avatar>
                      : data.state <= data.colors.amber 
                        ? <Avatar variant='rounded' style={{ color: '#fff', backgroundColor: amberColor, height: 30 }}>{data.state}</Avatar>
                        : <Avatar variant='rounded' style={{ color: '#fff', backgroundColor: greenColor, height: 30 }}>{data.state}</Avatar>}
                    {/* data.state === null
                        ? <Avatar variant='rounded'  className={classesForm.avatarGreenSquare}><Today /></Avatar>
                        : data.state < 0
                          ? <Avatar variant='rounded' className={classesForm.avatarRedSquare}>{data.state === 0 ? data.state : ''}</Avatar>
                          : data.state > 2
                            ? <Avatar variant='rounded' className={classesForm.avatarGreenSquare}>{data.state}</Avatar>
                            : <Avatar variant='rounded'  className={classesForm.avatarAmberSquare}>{data.state}</Avatar>
                    */}
                  </TableCell>
                  <TableCell align='left'>{data.from && moment(data.from).format('DD-MM-YYYY')}</TableCell>
                  <TableCell align='left'>{data.to && moment(data.to).format('DD-MM-YYYY')}
                    {/*
                      // En cas de descomentar això, calcular la data mínima del calendari emprant la funció setMinDate() que hi ha a schedulesList.js
                      <TextField
                      disabled={data.state === null}
                      type='date'
                      value={moment(data.to).format('YYYY-MM-DD')}
                      onChange={(event) => {
                        sendNewSchedule(moment(event.target.value).format('YYYY-MM-DD'), data._id);
                      }}
                      inputProps={{ min: moment(data.to).format('YYYY-MM-DD') }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    /> */}
                  </TableCell>
                  {/* ATENCIÓ: Només un Admin pot ampliar el plaç de resposta d'un formulari */}
                  <TableCell align='left'>
                    {/* <IconButton disabled onClick={() => console.log('on click NOTIFICAR')}>
                      <Notifications />
                    </IconButton> */}
                    {data.patientName}
                  </TableCell>
                  <TableCell align='left'>{data.programName}</TableCell>
                  <TableCell align='left'>
                    <IconButton onClick={() => handleViewUserSchedule(data._id, data.programId, data.clinicianFormsPlatforms)}>
                      <Edit />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  colSpan={schedulesDataColumns + 2}
                  count={filteredSchedules.length}
                  rowsPerPageOptions={rowsPerPageOptions}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true,
                  }}
                  labelDisplayedRows={
                    ({ from, to, count }) => (
                      from + ' - ' + ((to !== -1 && to) || count) + ' ' + translations['_of'] + ' ' + ((count !== -1 && count) || (translations['_moreThan'] + ' ') + to)
                    )
                  }
                  labelRowsPerPage={translations['_rowsPerPage']}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </div>
    </React.Fragment>
  );
}

// Indica i controla els props que se han de passar al component
MySchedulesList.propTypes = {
  schedulesData: PropTypes.array.isRequired,
  editScheduleData: PropTypes.func.isRequired,
};
